import React from 'react'
import messages from '../../utils/messages'
import logo from "./../../assets/img/logo-acurio.svg";

const Footer = props => {
  const getDate = () => {
    var d = new Date();
    return d.getFullYear();
  }

  return (
    <footer className="section footer">
      <div className="container">
        <a href="http://acuriorestaurantes.net/" title="Acurio Restaurantes">
          <img className="footer-logo" src={logo} alt="Acurio Restaurantes" />
        </a>
        <p className="datos">© Copyright {getDate()} Tanta<span className="separador"> | </span>
          <span className="desarrollado-por">{props.lang === "es" ? messages.es.desarrollado : messages.en.desarrollado} <a href="http://unbuendia.pe" title="Unbuendia Estudio">unbuendia.pe</a>
          </span>
        </p>
      </div>
    </footer>
  )
}

export default Footer;
